import { render, staticRenderFns } from "./mainBlock.vue?vue&type=template&id=443b5042&scoped=true&"
import script from "./mainBlock.vue?vue&type=script&lang=js&"
export * from "./mainBlock.vue?vue&type=script&lang=js&"
import style0 from "./mainBlock.vue?vue&type=style&index=0&id=443b5042&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443b5042",
  null
  
)

export default component.exports